const getZipCodeQuery = (lat, long) => {
    const query = `
    query MyQuery {
      getZipCode(lat: "${lat}", long: "${long}")
    }`
    return query;
  };
  
  export { getZipCodeQuery };
  